export default __webpack_public_path__ + "0851b42.png";